import { render } from "./BusinessCompanyForm.vue?vue&type=template&id=6c95d8c1"
import script from "./BusinessCompanyForm.vue?vue&type=script&lang=js"
export * from "./BusinessCompanyForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__